import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: !!localStorage.getItem('token'),
  },
  mutations: {
    loginSuccess(state) {
      state.loggedIn = true;
    },

    logoutSuccess(state) {
      state.loggedIn = false;
    },
  },
  actions: {

  },
})
